import 'jquery-modal';
import PhotoGallery from './photo-gallery';

class Modal {
    /**
     * The Modal class provides an interface for the modal library we use.
     * An instance of Modal has open and close functions
     * @param  {object} config contains properties for isMobile, $slideshow, and slideNumberParam
     * @return {obj} instance of Modal
     */
    constructor(config) {
        this.isMobile = config.isMobile;
        this.$slideshow = config.$slideshow;
        this.slideNumberParam = config.slideNumberParam;
        this.hasModalBeenOpened = false;
        this.config = {
            clickClose: false,       // Allows the user to close the modal by clicking the overlay
            closeText: 'Close',     // Text content for the close <a> tag.
            closeClass: 'photo-gallery__modal__close',         // Add additional class(es) to the close <a> tag.
            modalClass: `photo-gallery__modal js-photo-gallery__modal--ads`
        };

        if (!this.isMobile) {
            this.config.closeText = '';
            this.config.fadeDuration = 450;
        }
    }

    /**
     * Opens the modal instance, and instantiantes an instance of PhotoGallery.
     * Also disables scrolling on the article beneath it by targeting html and body tags.
     * @return {undefined}
     */
    open() {
        const photoGalleryConfig = {
            $slideshow: this.$slideshow,
            modal: this,
            slideNumberParam: this.slideNumberParam,
            isMobile: this.isMobile
        };
        this.$myself = $(`<div tabindex=0 data-url="${this.$slideshow.data('url')}"></div>`).modal(this.config);
        if (this.isMobile) {
            this.myPhotoGallery = new PhotoGallery(photoGalleryConfig);
            this.myPhotoGallery.render();
            $('html , body').addClass('photo-gallery__modal--no-scroll');
        } else {
            this.$myself.on($.modal.OPEN, function onModalLoaded() {
                this.myPhotoGallery = new PhotoGallery(photoGalleryConfig);
                this.myPhotoGallery.render();
                $('html , body').addClass('photo-gallery__modal--no-scroll');
                this.$myself.focus();
            }.bind(this));
        }


    }

    /**
     * Closes the modal instance and enables scrolling on the article beneath it.
     * @return {undefined}
     */
    close() {
        this.myPhotoGallery.destroy();
        this.myPhotoGallery = null;
        this.$myself.remove();
        this.$myself = null;
        this.$slideshow = null;
        $('html , body').removeClass('photo-gallery__modal--no-scroll');
    }
}

export default Modal;
